import { Component, Input, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ITableModel } from "../../../shared/components/table/model/tableModel";
import { environment } from "../../../../environments/environment";
import { appService } from "../../../_services/app.service";
import { ToastrService } from "ngx-toastr";
import { Helpers } from "../../../helpers";
import { ScriptLoaderService } from "../../../../app/_services/script-loader.service";
import { PrintFormatsComponent } from "../../../print-formats/print-formats.component";
import { CookieService } from "ngx-cookie-service";
import { DecryptPipe } from "./../../../auth/_services/encrypt-decrypt.pipe";
import { OrdersService } from "../../services/orders/orders.service";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { QuotationlogComponent } from "../quotationlog/quotationlog.component";
import { PrintFormatsNewComponent } from "../../../print-formats-new/print-formats-new.component";

@Component({
  selector: "app-new-bid-details",
  templateUrl: "./new-bid-details.component.html",
  styleUrls: ["./new-bid-details.component.scss"],
})
export class NewBidDetailsComponent implements OnInit {
  tableDetails: ITableModel;
  PackageDetails: ITableModel;
  NewVehicleDetails: ITableModel;
  recordIncomeDetails: ITableModel;
  BidCriteriaDetails: ITableModel;
  SelectedCompanyLogoImg: any;
  SelectedCompanyLogo: any;
  @Input() data: any = {};
  dataReason: any = {};

  BidDetailData: any = {};
  OrderListDetails: any = [];
  VehicleDetails: any = [];
  PackageListDetails: any = [];
  RecordIncomeListDetails: any = [];
  NewVehicleListDetails: any = [];
  BiddingDetails: any = [];
  biddingendsin: any;
  interval: any;
  biddingduration: any;
  VehicleAvailableDate: any = "";
  BidRemark: any = "";
  totalBidAmount: number = 0;

  selectedVehicles: {
    bidDetailId: any;
    VehicleReqiredId: any;
    AvailableDate: any;
    VehicleAmount: any;
    Remark: any;
    VehicleTypeId: any;
  }[] = [];
  @Input() IndentId: any = "";
  @Input() TransporterId: any = "";
  @Input() isQuotation: boolean=false;
  BidTransporter: any = {};
  VehicleBidList: any[];
  whitelabelFlag: boolean = false;
  VehicleReqiredId: any
  VehicleTypeId: any;

  isSubmitDisable: boolean;
  isBidClosed: boolean = false;
  // @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  @ViewChild(PrintFormatsNewComponent) PrintFormatsChild: PrintFormatsNewComponent;
  CompanyId: any;
  userId: any;
  @ViewChild("RejectQuotationModal") RejectQuotationModal: TemplateRef<any>;
  modalRefOrder: NgbModalRef | null = null;
  //added by BURHAN - 13-May-2026
  @ViewChild('attachment') attachment: TemplateRef<any>;
  attachmentModalRef: NgbModalRef | null = null;
  //end by BURHAN

  
  Reason: any = {
    lable: 'Change Reason',
    formControlName: 'Reason',
    dataField: 'Reason',
    isRequired: true,
    placeholder: 'Select Reason',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  QuotationRemark: any = {
    lable: "Remark",
    formControlName: 'QuotationRemark',
    dataField: 'QuotationRemark',
    isRequired: false,
    placeholder: "Enter remark",
    type: 'textarea'
  };

  showSo: boolean = false;
  @ViewChild(QuotationlogComponent) QuotationlogChild: QuotationlogComponent;

  //added by fahim 06-01-2026 :)
  Unit: any = {
    // lable: 'Unit',
    formControlName: 'Unit',
    dataField: 'Unit',
    isRequired: false,
    placeholder: 'Select Unit',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  Rate = {
    // lable: 'Rate',
    formControlName: 'Rate',
    dataField: 'Rate',
    isRequired: true,
    placeholder: 'Enter Rate',
    type: 'number'
  };

  ShipNowChargeBreakupList:any=[];  
  changeChargeBreakupList:any=[];  
  selectedRate=0;  //added by fahim 05-01-2026 :)
  selectedAmount=0;  //added by fahim 05-01-2026 :)
  totalChargeRateAmount: number = 0;
  //End added by fahim 06-01-2026 :)
  //added by BURHAN - 13-May-2026
  canViewAttachment: boolean = false;
  canEditAttachment: boolean = false;
  isAttachmentShow: boolean = false;
  ListDropdownType: string = 'Actions';
  //end by BURHAN

  isOrderFormSubmit:boolean=false

  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private activatedRoute: ActivatedRoute,
    private _script: ScriptLoaderService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private orderService: OrdersService,
    private modalService: NgbModal,
    private orderservice: OrdersService,
  ) { }

  ngOnInit() {
    this.loadAttachmentSettings();//added by BURHAN - 13-May-2026
    this._script.loadScripts(
      "body",
      [
        "assets/vendors/base/vendors.bundle.js",
        "assets/demo/default/base/scripts.bundle.js"
      ],
      true
    )
      .then(() => {
        this.activatedRoute.params.subscribe((params: Params) => {
          this.IndentId = this.activatedRoute.snapshot.queryParams["IndentId"];
          this.TransporterId = this.activatedRoute.snapshot.queryParams["Transporter"];
          this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));
          // this.isQuotation = this.activatedRoute.snapshot.queryParams["isQuotation"];
          this.isQuotation = this.activatedRoute.snapshot.queryParams["isQuotation"] === 'true';
          
           console.log(this.isQuotation, typeof this.isQuotation);
          console.log('isQuotation above if part',this.isQuotation);
          if(this.isQuotation){
            if (this.IndentId) {
              this.BiddingList();
              this.NewVehicleList();
              this.GetOrderQuoteDetails();
            }
          } else{
            if (this.IndentId == undefined || this.IndentId == null) {
              this.IndentId = this.activatedRoute.snapshot.queryParams["indentid"];
              this.TransporterId = this.activatedRoute.snapshot.queryParams["transporter"];
              this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelflag"));
            }
            if (this.IndentId !== undefined && this.IndentId !== null) {
              this.BiddingList();
              this.GetBidDetails();
              this.GetShipNowChargeBreakupList();
              this.GetNewUnitsList('%%');
            }
          }
        });
        this.calculateTotalBidAmount();
      });
    this.SelectedCompanyLogo = JSON.parse(
      localStorage.getItem("ChnageCompnayId")
    ).CompanyLogoPath;
    this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.interval = setInterval(() => this.calculateTimeRemaining(), 1000);
  }

  ngOnDestroy() {
    // Clear interval when the component is destroyed to avoid memory leaks
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  calculateTimeRemaining() {
    // added by priya - 28/01/25
    if (!this.biddingduration) {
      console.log('Bidding duration is not available.');
      return;
    }
    const biddingEndDate = new Date(this.biddingduration);
    // Get the current date and time in UTC
    const currentDate = new Date();
    // Log both dates to check if they are correct
    // console.log('Bidding End Date (UTC):', biddingEndDate.toISOString());
    // console.log('Current Date (UTC):', currentDate.toISOString());
    // Calculate the difference in milliseconds
    const timeDifference = biddingEndDate.getTime() - currentDate.getTime();
    // Log the time difference
    // console.log('Time Difference in Milliseconds:', timeDifference);
    // If the bidding time has passed
    if (timeDifference <= 0) {
      this.biddingendsin = `00days 00h 00m 00s`;
      this.isSubmitDisable = false;
      // console.log('Bidding has ended.');
      if (this.interval) {
        clearInterval(this.interval); // Stop the timer
      }
      return;
    } else {
      this.isSubmitDisable = true;
    }
    // Calculate days, hours, minutes, and seconds for the remaining time
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    // Format the result and display it
     if (days > 0) {
      this.biddingendsin = `${days.toString().padStart(2, "0")}days ${hours.toString().padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
     }else{
      this.biddingendsin = `${hours.toString().padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
     }

    // console.log('Time remaining:', this.biddingendsin);
  }

  BidAmount: any = {
    lable: "",
    formControlName: "BidAmount",
    dataField: "BidAmount",
    isRequired: false,
    placeholder: "Enter your bid amount",
    type: "number",
  };
  Remark: any = {
    lable: "",
    formControlName: "Remark",
    dataField: "Remark",
    isRequired: false,
    placeholder: "Enter remark",
    type: "text",
  };

  AvailableDate: any = {
    lable: "",
    formControlName: "AvailableDate",
    dataField: "AvailableDate",
    isRequired: false,
    // added by priya - 28/01/25
    isTime: true,
    placeholder: "Select Date",
  };

  Orderdetail: any = {
    cardName: "Indent No",
    NewHeaderData: true,
    id: "orderInfo",
    isTableCardView: false,
    isShowOrderNo: true,
    // IndentNo:"OrderNo",
    // NewlistOfRow: [
    //   [
    //     {
    //       label: "",
    //       dataField1: "OrderNo",
    //     },
    //   ]
    // ],
    listOfRow: [
      [
        {
          label: "Pickup",
          dataField: "PickUpContactPerson",
          dataField1: "PickupAddress",
        },
        {
          label: "Delivery",
          dataField: "DeliveryContactPerson",
          dataField1: "DeliveryAddress",
        },
      ],
      [
        { label: "Pickup Date", dataField: "PickupDate" },
        { label: "Delivery Date", dataField: "DeliviryDate" },
      ],
      [
        { label: "Remark", dataField: "Remarks" } // Added by priya - 11/05/2026 - cn(PRIYA-MAY26-003)
      ]
    ],
    isColumnNameShow: true,
  };

  TransporterDetails: any = {
    cardName: "Transporter Details",
    id: "orderInfo",
    listOfRow: [
      [
        {
          dataField: "Transporter",
          // dataField1: "TransportModeType",
          imgDataField: "LogoPath",
          valueType: "isNewTransporter",
          isNewRating: true,
          dataFieldRating: "StarRating",
        },
      ],
      [{ isNewHrLine: true }],
      [
        {
          phonedataField: "TransporterPhone",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/phone.svg",
          isNewPhone: true,
          color: "#3b67fb",
        },
      ],
      [
        {
          EmaildataField: "TransporterEmail",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/newemail.svg",
          isNewEmail: true,
          color: "#3b67fb",
        },
      ],
    ],
    isColumnNameShow: true,
  };

  CustomerDetails: any = {
    cardName: "Customer Details",
    id: "orderInfo",
    listOfRow: [
      [
        {
          dataField: "CustomerName",
          // dataField1: "TransportModeType",
          imgDataField: "LogoPath",
          valueType: "isNewTransporter",
          isNewRating: true,
          dataFieldRating: "StarRating",
        },
      ],
      [{ isNewHrLine: true }],
      [
        {
          phonedataField: "CustomerPhone",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/phone.svg",
          isNewPhone: true,
          color: "#3b67fb",
        },
      ],
      [
        {
          EmaildataField: "CustomerEmail",
          isNewIcon: true,
          NewlogoIcon: "../../../../assets/svg/Design/newemail.svg",
          isNewEmail: true,
          color: "#3b67fb",
        },
      ],
    ],
    isColumnNameShow: true,
  };

  async BiddingList() {
    this.PackageDetails = {
      data: [],
      columnDetails: [
        { columnName: "Product Name", dataFieldName: "ProductName" },
        { columnName: "Qty", dataFieldName: "Qty" },
        { columnName: "Weight", dataFieldName: "weight" },
        { columnName: "CBM", dataFieldName: "CBM" },
        { columnName: "Amount", dataFieldName: "InvoiceAmount" },
      ],
      footerData: [
        { ProductName: "Total", Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true,
    };
  }

  async NewVehicleList() {
    this.NewVehicleDetails = {
      data: [],
      columnDetails: [
        { columnName: "Vehicle Type", dataFieldName: "VehicleName" },
        { columnName: "Qty", dataFieldName: "Qty" },
        { columnName: "Weight", dataFieldName: "weight" },
        { columnName: "Specifications", dataFieldName: "Specifications" },
      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: false,
    };

    this.recordIncomeDetails = {
      data: [],
      emptyDataMSg: "No Records Found",
      columnDetails: [
        { columnName: "Charge", dataFieldName: "ChargeCode", },
        { columnName: "Unit", dataFieldName: "Unit", },
        { columnName: "Charge GST", dataFieldName: "ChargedGST", },
        { columnName: "Qty", dataFieldName: "Quantity",alignType:'right' },
        { columnName: "Rate", dataFieldName: "Rate", alignType:'right'},
        { columnName: 'Discount', dataFieldName: 'Discount',alignType:'right' },
        { columnName: "Amount", dataFieldName: "Amount", alignType:'right'},
        { columnName: "Advance", dataFieldName: "Advance",alignType:'right' },
        { columnName: "Remark", dataFieldName: "Remark" },
      ],
      footerData: [
        { ChargeCode: 'Total', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },
        { ChargeCode: 'CGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },
        { ChargeCode: 'SGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },
        { ChargeCode: 'IGST', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },
        { ChargeCode: 'Round Off', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },
        { ChargeCode: 'NetTotal', Unit: '', ChargedGST: '', Quantity: '', Rate: '', Discount: '', Amount: '0', Advance: '', Remark: '' },

      ],
      actionList: [],
      isColumnNameShow: true,
      isShowFooterData: true,
    };
  }

  getChangedValue(value, field, row) {

    if (field.dataField == "BidAmount") {
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        VehicleAmount: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field.dataField == "Remark") {
      this.BidTransporter.Remark = value;
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        Remark: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field.dataField == "AvailableDate") {
      this.VehicleReqiredId = row.OrdersItemByVehicleId
      this.VehicleTypeId = row.VehicleTypeId
      this.updateSelectedVehicle({
        AvailableDate: value,
        bidDetailId: row.Id,
        VehicleReqiredId: row.OrdersItemByVehicleId,
        VehicleTypeId: row.VehicleTypeId
      });
    }
    if (field.dataField == "VehicleTypeId") {
      if(value){
        this.updateSelectedVehicle({
          bidDetailId: row.Id,
          VehicleReqiredId: row.OrdersItemByVehicleId,
          VehicleTypeId: value.value
        });
        this.UpdateChargesList(value.value,value.name);
        this.UpdateBiddingDetails(row.Id,value.value);
      }else{
        this.updateSelectedVehicle({
          bidDetailId: row.Id,
          VehicleReqiredId: row.OrdersItemByVehicleId,
          VehicleTypeId: null
        });
        this.UpdateChargesList(null,null);
        this.UpdateBiddingDetails(row.Id,null);
      }
    }
    this.calculateTotalBidAmount();
    console.log("BidTransporter:", this.BidTransporter);
    console.log("getChangedValue selectedVehicles:", this.selectedVehicles);
  }

  updateSelectedVehicle(
    updatedFields: Partial<{
      bidDetailId: any;
      VehicleReqiredId: any;
      AvailableDate: any;
      VehicleAmount: any;
      Remark: any;
      VehicleTypeId: any,
    }>
  ) {
    const existingVehicle = this.selectedVehicles.find(
      (vehicle) => vehicle.bidDetailId === updatedFields.bidDetailId
    );

    if (existingVehicle) {
      Object.assign(existingVehicle, updatedFields);
      console.log("BidTransporter existingVehicle:", this.selectedVehicles);
    } else {
      //   
      // Add a new entry with default values
      this.selectedVehicles.push({
        bidDetailId: null,
        VehicleReqiredId: null,
        AvailableDate: null,
        VehicleAmount: null,
        Remark: '',
        VehicleTypeId: null,
        ...updatedFields,
      });

      this.calculateTotalBidAmount();

      console.log("BidTransporter Not existingVehicle:", this.selectedVehicles);
    }
  }

  calculateTotalBidAmount(): void {
    this.totalBidAmount = this.selectedVehicles.reduce((total, vehicle) => {
      const amount = parseFloat(vehicle.VehicleAmount);
      return total + (isNaN(amount) ? 0 : amount);
    }, 0);
  }

  GetBidDetails() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetBiddingDetails", this.IndentId, this.TransporterId).subscribe((res) => {
      this.BidDetailData = res;
      this.OrderListDetails = this.BidDetailData.Table[0];
      this.biddingduration = this.BidDetailData.Table[0].BidDuration;
      this.VehicleDetails = this.BidDetailData.Table1;
      this.PackageListDetails = this.BidDetailData.Table2;
      this.BiddingDetails = this.BidDetailData.Table3;
      console.log("OrderDetails", this.OrderListDetails);
      this.PackageDetails.data = this.PackageListDetails;
      const totals = this.PackageListDetails.reduce(
        (acc, item) => {
          acc.Qty += item.Qty || 0;
          acc.weight += item.weight || 0;
          acc.CBM += item.CBM || 0;
          acc.InvoiceAmount += item.InvoiceAmount || 0;
          return acc;
        },
        { Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 }
      );
      this.PackageDetails.footerData[0] = {
        ProductName: "Total",
        Qty: totals.Qty,
        weight: totals.weight,
        CBM: totals.CBM,
        InvoiceAmount: totals.InvoiceAmount,
      };
      if (this.BidDetailData.Table[0].BidOpen === true) {
        this.isBidClosed = true;
      } else {
        this.isBidClosed = false;
      }

      if (this.BiddingDetails && this.BiddingDetails.length > 0) {
        for (let i = 0; i < this.BiddingDetails.length; i++) {
          const bd = this.BiddingDetails[i];

          this.selectedVehicles.push({
            bidDetailId: bd.Id,
            VehicleReqiredId: bd.OrdersItemByVehicleId,
            AvailableDate: bd.AvailableDate_bid,
            VehicleAmount: bd.Amount, 
            Remark: bd.Remark,
            VehicleTypeId: bd.VehicleTypeId
          });
        }
      }

      let TransportService = this.OrderListDetails && this.OrderListDetails.TransportService ?  this.OrderListDetails.TransportService : null;
      console.log('TransportService',TransportService);
      this.AddVehicleTypeDropDown(TransportService);
      this.calculateTimeRemaining();
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        console.error("GetBidDetails", error);
      });
  }
  isSubmitting = false;
  hasSubmitted = false;
  // SubmitTransporterBids() {
  //   if (this.isSubmitting || this.hasSubmitted) {
  //     console.log('Saving... or Already Saved');
  //     return; 
  //   }
  //   this.isSubmitting = true;
  //   this.calculateTotalBidAmount();
  //   this.GetTotalAmount();
  //   const invalidVehicles = this.selectedVehicles.filter(
  //     (vehicle) => vehicle.VehicleAmount > this.OrderListDetails.MinBidAmount
  //   );

  //   if (invalidVehicles.length > 0) {
  //     this.toastr.error(
  //       "Amount should be less than the maximum bid amount",
  //       "Error"
  //     );
  //     console.log("Invalid vehicles:", invalidVehicles);
  //     this.isSubmitting = false; 
  //     return; // Stop submission
  //   }
  //   this.BidTransporter.IndentId = this.IndentId;
  //   this.BidTransporter.TransporterId = this.TransporterId;
  //   // this.BidTransporter.Amount = this.totalChargeRateAmount ? this.totalChargeRateAmount : this.totalBidAmount;
  //   this.BidTransporter.Amount = this.totalChargeRateAmount !== null && this.totalChargeRateAmount !== undefined && this.totalChargeRateAmount !== 0 ? this.totalChargeRateAmount : this.totalBidAmount;
  //   this.BidTransporter.BiddingDetails = this.selectedVehicles;
  //   console.log('biddingdetail', this.BidTransporter)

  //   console.log('selectedVehicles', this.BidTransporter)
  //   this._appService.Post("OrdersByVehicle", "UpdateNewTransporterBid", this.BidTransporter).subscribe((response) => {
  //     Helpers.setLoading(false);
  //     this.isSubmitting = false; 
  //     if (response[0].isDone) {
  //       this.toastr.success("Bid Sumbitted sucessfully !", "Success");
  //       this.hasSubmitted = true; 
  //     } else {
  //       this.toastr.error("Your Bid Submission Failed !", "Error");
  //     }
  //     if (!this.hasSubmitted) {
  //       this.isSubmitting = false;
  //     }
  //   },
  //     (err) => {
  //       console.log(err);
  //       Helpers.setLoading(false);
  //       this.isSubmitting = false; 
  //       this.toastr.error(err._body.replace(/"/g, ""), "Error");
  //     });
  // }

  GetOrderQuoteDetails() {
    Helpers.setLoading(true);
    this._appService.GetByTwoId("OrdersByVehicle", "GetOrderQuoteDetails", this.IndentId, this.TransporterId).subscribe((res) => {
      this.BidDetailData = res;
      this.OrderListDetails = this.BidDetailData.Table[0];
      this.NewVehicleListDetails = this.BidDetailData.Table1;
      this.PackageListDetails = this.BidDetailData.Table2;
      this.RecordIncomeListDetails = this.BidDetailData.Table3;
      console.log("OrderDetails", this.OrderListDetails);
      this.NewVehicleDetails.data = this.NewVehicleListDetails;
      this.recordIncomeDetails.data = this.RecordIncomeListDetails;
      this.PackageDetails.data = this.PackageListDetails;
      const totals = this.PackageListDetails.reduce(
        (acc, item) => {
          acc.Qty += item.Qty || 0;
          acc.weight += item.weight || 0;
          acc.CBM += item.CBM || 0;
          acc.InvoiceAmount += item.InvoiceAmount || 0;
          return acc;
        },
        { Qty: 0, weight: 0, CBM: 0, InvoiceAmount: 0 }
      );
      this.PackageDetails.footerData[0] = {
        ProductName: "Total",
        Qty: totals.Qty,
        weight: totals.weight,
        CBM: totals.CBM,
        InvoiceAmount: totals.InvoiceAmount,
      };
      if(this.RecordIncomeListDetails.length > 0){
        this.CalcFooterValue();
      }
      Helpers.setLoading(false);
    },
      (error) => {
        Helpers.setLoading(false);
        console.error("GetBidDetails", error);
      });
  }

  CalcFooterValue() {
    var sumofTotal = 0;
    let SGST: any = 0.0;
    let CGST: any = 0.0;
    let IGST: any = 0.0;

    var TotalQty = 0;
    var TotalAmount = 0;
    var NetTotalAmount = 0;
    var RoundOfAmount = 0;
    var TotalCGST = 0;
    var TotalSGST = 0;
    var TotalIGST = 0;
    var TotalDiscount = 0;
    var TotalAdvance = 0;

    this.recordIncomeDetails.data.forEach((element) => {
      sumofTotal += parseFloat(element.Amount);
      SGST = 0.0;
      CGST = 0.0;
      IGST = 0.0;
      if (
        element.Discount == null ||
        element.Discount == undefined ||
        element.Discount == ""
      ) {
        element.Discount = 0;
      }
      element.Amount = element.Quantity * element.Rate;
      element.Amount = element.Amount - element.Discount;

      if (element.ChargedGST != 'NA') {
        if (element.CGST != null && element.CGST != 0) {
          CGST = element.Amount * (element.CGST / 100);
        }
        if (element.SGST != null && element.SGST != 0) {
          SGST = element.Amount * (element.SGST / 100);
        }
        if (element.IGST != null && element.IGST != 0) {
          IGST = element.Amount * (element.IGST / 100);
        }
        // if (taxvalue == 0 && element.ChargedGST != 'NA') {
        //     TotalIGST = 0,
        //     TotalIGST = 0,
        //     TotalSGST = 0
        // }
      }
      else {
        element.ChargedGST = "NA";
        element.ChargedGSTId = null;
      }

      TotalAmount += element.Amount;
      TotalDiscount += parseFloat(element.Discount);
      TotalQty += parseFloat(element.Quantity);
      TotalAdvance += parseFloat(element.Advance);

      element.CGSTAmount = CGST;
      element.SGSTAmount = SGST;
      element.IGSTAmount = IGST;
      TotalCGST += CGST;
      TotalSGST += SGST;
      TotalIGST += IGST;
    });

    TotalAdvance = parseFloat(TotalAdvance.toFixed(2));
    NetTotalAmount = TotalAmount + TotalCGST + TotalSGST + TotalIGST;
    RoundOfAmount = parseFloat((Math.round(NetTotalAmount) - NetTotalAmount).toFixed(2));
    NetTotalAmount = Math.round(NetTotalAmount);

    setTimeout(() => {
      this.recordIncomeDetails.footerData[0].Amount = parseFloat(sumofTotal.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[0].Quantity = parseFloat(TotalQty.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[0].Discount = parseFloat(TotalDiscount.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[0].Advance = parseFloat(TotalAdvance.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[1].Amount = parseFloat(TotalCGST.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[2].Amount = parseFloat(TotalSGST.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[3].Amount = parseFloat(TotalIGST.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[4].Amount = parseFloat(RoundOfAmount.toString()).toFixed(2);
      this.recordIncomeDetails.footerData[5].Amount = parseFloat(NetTotalAmount.toString()).toFixed(2);

    }, 500);
  }

  PrintQuote(){
    this.PrintFormatsChild.OrderId = this.IndentId;
    // this.PrintFormatsChild.InvoiceType = 'NewPrintQuote';
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompanyId = this.CompanyId;
    this.PrintFormatsChild.NewPrintQuote();
  }

  ApproveQuotaion(){
    this._appService.GetByTwoId('OrdersByVehicle','SaveApproveQuotaion',this.IndentId,'Approved').subscribe(
      (response)=>{
        this.toastr.success('Quotation approved successfully.','Success');
        this.UpdateLog('Approved');
        this.GetOrderQuoteDetails();
        this.sendQuoteConfirmMail();
      },
      (Error)=>{
        this.toastr.success('Error occurred while approving the data.','Error');
      }
    )
  }

    GetReasonList(value, isScrollDown = false) {
    this.Reason.isSearch = true;
    let type = 'Approval'
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Reason.dropdownList.length / 20) + 1;
    }
    this.orderService.ReasonSelect2(value, pageNo, type).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Reason.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Reason.dropdownList);
        this.Reason = { ...this.Reason, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Reason = { ...this.Reason, dropdownList: [...dropdownList] });
      this.Reason.isSearch = false;
    }).catch(error => {
      this.Reason.isSearch = false;
    })
  }

  getChangedValueReason(value, data) {
    if (value) {
      if(data.dataField === 'QuotationRemark'){
        this.dataReason[data.dataField] = value;
      }else{
        this.dataReason[data.dataField] = value.value;
      }
    }else{
      this.dataReason[data.dataField] = null;
    }
  }

  RejectQuotaion(){
    this.modalRefOrder = this.modalService.open(this.RejectQuotationModal, { centered: true, size: "lg", windowClass: "modal-custom-UnconfirmOrderModal" });
  }

  SaveReject(){
    if(!this.dataReason.Reason){
      this.toastr.warning('Please select reason','Warning');
      return;
    }
    this._appService.GetByTwoId('OrdersByVehicle','SaveApproveQuotaion',this.IndentId,'Reject').subscribe(
      (response)=>{
        this.toastr.success('Quotation updated successfully.','Success');
        this.UpdateLog('Reject');
        this.GetOrderQuoteDetails();
        this.modalRefOrder.close();
      },
      (Error)=>{
        this.toastr.success('Error occurred while approving the data.','Error');
      }
    )
  }

  UpdateLog(Status){
    const payload = {
      OrderId: this.IndentId,
      Reason: this.dataReason.Reason,
      FromEmail: '',
      ToEmail: '',
      TransactionType: 'Quotation',
      Status: Status,
      Remark: this.dataReason.QuotationRemark,
      TotalAmount: this.recordIncomeDetails.footerData[5].Amount,
      CreatedBy: this.userId
    };
    this._appService.Post("OrdersByVehicle", "InsertOrderQuotationLog", payload).subscribe(
      (response) => {
            Helpers.setLoading(false);
            this.dataReason = {};
      },
      (err) => {
            this.toastr.error(err._body.replace(/"/g, ""), "error");
            this.dataReason = {};
      }
    );
  }

  OnClickSo() {
    this.showSo = !this.showSo;
    this.QuotationlogChild.GetQuotationLogList(this.IndentId);
  }

  // GetNewUnitsList(val){
  //   this._appService.GetByQuery('OrdersByVehicle','GetNewUnitsList',val).subscribe(
  //     (response)=>{
  //       if(response && response.length>0){
  //         this.Unit.dropdownList=response || [];
  //       }
  //     },
  //     (error)=>{
  //       this.toastr.error('Error while getting Unit List','Error')
  //     }
  //   );
  // }

  getChangedValueForRate(value, field,val) {
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if(newValue){
      if (field.dataField == "Rate") {
        console.log('newValue',newValue);
        this.selectedRate=0;
        if(newValue){
          this.selectedRate=Number(newValue)
        }

        const rate = Number(newValue) || 0;

        const updatedRow = this.ShipNowChargeBreakupList.find(x => x.Id === val.Id);
        if (updatedRow) {
            updatedRow.Amount = updatedRow.Qty * rate;
            updatedRow.Rate =  rate;
        }

        this.GetTotalAmount();
      }
      if (field.dataField == "Unit") {
        console.log('newValue',newValue);

        const updatedRow = this.ShipNowChargeBreakupList.find(x => x.Id === val.Id);
        if (updatedRow) {
          updatedRow.Unit = newValue;
        }
        this.CalculateChargesByUnit(val.IndentId,val.TransporterId,newValue,val.Id);
      }
    }else{
      
    }
  }

  GetShipNowChargeBreakupList() {
  Helpers.setLoading(true)
  this._appService.GetByThreeId('OrdersByVehicle', 'GetShipNowChargeBreakupList', this.IndentId, this.TransporterId,true).subscribe(
    (response) => {
      if(response.length){
        this.ShipNowChargeBreakupList = response || [];
        this.ShipNowChargeBreakupList = response.map((item, index) => {
          return {
            ...item,
            SerialNumber: index + 1
          };
        });
        this.BidAmount.isReadOnly=true;

        this.Unit.dropdownList = this.ShipNowChargeBreakupList.map((res: any) => ({
          name: res.Unit,
          value: res.Unit
        }));

        this.changeChargeBreakupList=this.ShipNowChargeBreakupList;
      }
      this.GetTotalAmount();
      // this.CalFooterValue();
      Helpers.setLoading(false)
    },
    (err) => {
      this.toastr.error("Error occurred while fetching data !", "error");
      Helpers.setLoading(false)
    }
  );
  }

  GetNewUnitsList(value, isScrollDown = false) {
    console.log(this.data, 'data')
    this.Unit.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Unit.dropdownList.length / 20) + 1;
    }
    this.orderservice.GetNewUnitsList(value).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Unit.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Unit.dropdownList);
        this.Unit = { ...this.Unit, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Unit = { ...this.Unit, dropdownList: [...dropdownList] });
      this.Unit.isSearch = false;
    }).catch(error => {
      this.Unit.isSearch = false;
    })
  }

  CalculateChargesByUnit(OrderId,NetworkId,ChargesPer,selectedId){
    let obj:any={};
    obj.OrderId=OrderId;
    obj.NetworkId=NetworkId;
    obj.ChargesPer=ChargesPer;
    obj.UnitRate=0;
    this._appService.Post('OrdersByVehicle','CalculateChargesByUnit',obj).subscribe(
      (response)=>{
        if(response && response.length>0){
           console.log(response[0].Qty);
           const newQTY = response[0].Qty
            const updatedRow = this.ShipNowChargeBreakupList.find(x => x.Id === selectedId);
            if (updatedRow) {
                updatedRow.Qty = newQTY;
                updatedRow.Amount = newQTY * updatedRow.Rate;
            }

            this.GetTotalAmount();
        }
      },
      (error)=>{
        this.toastr.error('Error while calculating qty','Error');
      }
    );
  }

  onSaveChargeBreakup(row: any){
    // if(this.selectedRate === 0){
    //   this.selectedRate = row.Rate;
    //   this.selectedAmount = row.Amount;
    // }else{
    //   this.selectedAmount = row.Amount;
    // }
    let Id=row.Id;
    let Rate=row.Rate;
    let Amount=row.Amount;
    let Qty=row.Qty;
    let Unit=row.Unit;
    let VehicleTypeId=row.VehicleTypeId;
    this._appService.GetBySevenId('OrdersByVehicle','UpdateShipNowChargeBreakupRate',Id,Rate,Amount,Qty,this.userId,Unit,VehicleTypeId).subscribe(
      (response)=>{
        this.toastr.success('Rate updated successfully','Success');
        this.GetShipNowChargeBreakupList();
      },
      (error)=>{
        this.toastr.error('Error while updating Rate','Error');
      }
    )
  }

  GetTotalAmount() {
    if (!this.ShipNowChargeBreakupList || this.ShipNowChargeBreakupList.length === 0) {
      this.totalChargeRateAmount = 0;
    
      // this.selectedVehicles.forEach(vehicle => {
      //   vehicle.VehicleAmount = 0;
      // });

      return;
    }

    this.totalChargeRateAmount = this.ShipNowChargeBreakupList.reduce(
      (sum: number, item: any) => sum + (Number(item.Amount) || 0),
      0
    );

    // this.selectedVehicles.forEach(vehicle => {
    // const charge = this.ShipNowChargeBreakupList.find(
    //   x => x.VehicleTypeId === vehicle.VehicleTypeId
    // );

    // vehicle.VehicleAmount = charge && charge.Amount ? Number(charge.Amount) : 0;
    // });

    // this.BiddingDetails.forEach(vehicle => {
    // const charge = this.ShipNowChargeBreakupList.find(
    //   x => x.VehicleTypeId === vehicle.VehicleTypeId
    // );

    // vehicle.Amount = charge && charge.Amount ? Number(charge.Amount) : 0;
    // });

    //added by fahim 16-1-2026 :)
    const vehicleTypeSums: { [key: string]: number } = {};
    const vehicleTypeCounts: { [key: string]: number } = {};

    this.ShipNowChargeBreakupList.forEach(item => {
      const typeId = item.VehicleTypeId;
      const amount = Number(item.Amount) || 0;

      if (!vehicleTypeSums[typeId]) {
        vehicleTypeSums[typeId] = amount;
        vehicleTypeCounts[typeId] = 1;
      } else {
        vehicleTypeSums[typeId] += amount;
        vehicleTypeCounts[typeId] += 1;
      }
    });

    this.selectedVehicles.forEach(vehicle => {
      const typeId = vehicle.VehicleTypeId;
      if (vehicleTypeSums[typeId] !== undefined) {
        vehicle.VehicleAmount = vehicleTypeSums[typeId];
      } else {
        vehicle.VehicleAmount = 0;
      }
    });

    this.BiddingDetails.forEach(vehicle => {
      const typeId = vehicle.VehicleTypeId;
      if (vehicleTypeSums[typeId] !== undefined) {
        vehicle.Amount = vehicleTypeSums[typeId];
      } else {
        vehicle.Amount = 0;
      }
    });

    // this.selectedVehicles.forEach(vehicle => {
    //   vehicle.VehicleAmount = this.totalChargeRateAmount;
    // });

    // this.BiddingDetails.forEach(element => {
    //   element.Amount = this.totalChargeRateAmount;
    // });
    

    console.log('selectedVehicles',this.selectedVehicles);
    console.log('BiddingDetails',this.BiddingDetails);
  }

  saveShipNowChargeBreakup(callback: any) {
  const obj = {
    CreatedBy: this.userId,
    ShipNowChargeBreakup_Table: this.ShipNowChargeBreakupList,
    isBidding: true
  };
  this._appService
    .Post('OrdersByVehicle', 'SaveShipNowChargeBreakup', obj)
    .subscribe(
      (response) => {
        console.log('SaveShipNowChargeBreakup Success');
        callback(true);
      },
      (error) => {
        console.error('Error while saving SaveShipNowChargeBreakup');
        callback(false);
      }
    );
  }

  SubmitTransporterBids() {
    // if (this.isSubmitting || this.hasSubmitted) {
    //   return;
    // }

    this.isSubmitting = true;
    if(this.CheckVehicleMandatory === false){
      this.isOrderFormSubmit = true;
      const emptyid = "00000000-0000-0000-0000-000000000000";
      for (let index = 0; index < this.selectedVehicles.length; index++) {
        const items = this.selectedVehicles[index];
        if (!items.VehicleTypeId || items.VehicleTypeId === emptyid) {
          this.toastr.warning('Please select Vehicle Type','warning');
          return;
        }
      }
    }

    console.log('You can now proceed');

    if (!this.ShipNowChargeBreakupList || this.ShipNowChargeBreakupList.length === 0) {
      this.submitTransporterBidFinal();
      return;
    }

    if (this.totalChargeRateAmount > this.OrderListDetails.MinBidAmount && this.OrderListDetails.MaxBidAllowance == false) {// && this.OrderListDetails.MaxBidAllowance == false - added by BURHAN - 28-April-2026
      this.toastr.error(
        "Amount should be less than the maximum bid amount",
        "Error"
      );
      return; // Stop submission
    }

    this.saveShipNowChargeBreakup((isSaved: boolean) => {
      if (!isSaved) {
        this.toastr.error('Failed to save charge breakup', 'Error');
        this.isSubmitting = false;
        return;
      }

      this.submitTransporterBidFinal();
    });
  }



  submitTransporterBidFinal(){
    this.calculateTotalBidAmount();
    this.GetTotalAmount();

    const totalVehicleAmount = this.selectedVehicles.reduce(
      (sum, vehicle) => sum + (Number(vehicle.VehicleAmount) || 0),
      0
    );

    const amountToValidate = this.totalChargeRateAmount != null && this.totalChargeRateAmount !== 0 ? Number(this.totalChargeRateAmount) : totalVehicleAmount;
      
    if (amountToValidate > this.OrderListDetails.MinBidAmount && this.OrderListDetails.MaxBidAllowance == false) {// && this.BidDetailData.MaxBidAllowance == false added by BURHAN - 28-April-2026
      this.toastr.error(
        "Amount should be less than the maximum bid amount",
        "Error"
      );
      console.log("Invalid vehicles:", totalVehicleAmount);
      this.isSubmitting = false; 
      return; // Stop submission
    }
    this.BidTransporter.IndentId = this.IndentId;
    this.BidTransporter.TransporterId = this.TransporterId;
    // this.BidTransporter.Amount = this.totalChargeRateAmount ? this.totalChargeRateAmount : this.totalBidAmount;
    this.BidTransporter.Amount = this.totalChargeRateAmount !== null && this.totalChargeRateAmount !== undefined && this.totalChargeRateAmount !== 0 ? this.totalChargeRateAmount : this.totalBidAmount;
    this.BidTransporter.BiddingDetails = this.selectedVehicles;
    console.log('biddingdetail', this.BidTransporter)

    console.log('selectedVehicles', this.BidTransporter)
    this._appService.Post("OrdersByVehicle", "UpdateNewTransporterBid", this.BidTransporter).subscribe((response) => {
      Helpers.setLoading(false);
      this.isSubmitting = false; 
      if (response[0].isDone) {
        this.toastr.success("Bid Sumbitted sucessfully !", "Success");
        this.hasSubmitted = true; 
      } else {
        this.toastr.error("Your Bid Submission Failed !", "Error");
      }
      if (!this.hasSubmitted) {
        this.isSubmitting = false;
      }
    },
      (err) => {
        console.log(err);
        Helpers.setLoading(false);
        this.isSubmitting = false; 
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      });
  }

  async sendQuoteConfirmMail(){
    this.PrintFormatsChild.divElements = null;
    this.PrintFormatsChild.OrderId = this.IndentId;
    this.PrintFormatsChild.UserId = this.userId;
    this.PrintFormatsChild.CompanyId = this.CompanyId;

    await new Promise<void>((resolve) => {
      const sub = this.PrintFormatsChild.renderComplete.subscribe(() => {
        resolve();
        sub.unsubscribe(); // avoid memory leaks
      });

      this.PrintFormatsChild.NewPrintQuoteHtmlOnly();
    });

    let obj: any = {
      userId: this.userId,
      companyId: this.CompanyId,
      OrderId: this.IndentId,
      QuotePrintHtml:this.PrintFormatsChild.divElements
    };
    console.log('sendQuoteConfirmMail obj',obj);

    this._appService.Post('OrdersByVehicle','sendQuoteConfirmMail',obj).subscribe(
      (response)=>{
        this.toastr.success('Quotation Confirmation mail sent successfully','Success');
      },
      (error)=>{
        this.toastr.error('Error while sending Quotation Confirmation Mail','Error');
      }
    )
  }

  VehicleType:any={
    lable: '',
    formControlName: 'VehicleTypeId',
    dataField: 'VehicleTypeId',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  }

  CheckVehicleMandatory:boolean=true;
  AddVehicleTypeDropDown(Id:any){
    this._appService.GetById("OrdersByVehicle", "CheckforVehicleMandatory", Id).subscribe(
      (response) => {
        if (response && response.length>0) {
          const Item = response[0];

          if (Item && typeof Item.CheckVehicleMandatory === 'boolean') {
            this.CheckVehicleMandatory = Item.CheckVehicleMandatory;
            this.GetVehicleTypeList('%%',false);
          } else {
            this.CheckVehicleMandatory = true; 
          }
        } else {
          this.CheckVehicleMandatory = true; 
        }

        console.log('this.CheckVehicleMandatory',this.CheckVehicleMandatory);
      },
      (err)=>{
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
      }
    );
  }

  GetVehicleTypeList(value:any, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this._appService.GetByOneParam('Vahicle', 'GetNewVehicleTypeList', value).subscribe(
      (res) => {
        let response = res || []; 
        let dropdownList = [...response];   
        if (
          isScrollDown &&
          response &&
          response.Total &&
          response.Total > this.VehicleType.dropdownList.length
        ){
          dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
          this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
        }
        if (!isScrollDown) {
          this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
        }
        this.VehicleType.isSearch = false;
      },
      (error) => {
        this.VehicleType.isSearch = false;
        this.toastr.error(error._body.replace(/"/g, ""), "Error");
      }
    ); 
  }

  UpdateChargesList(Id,Name){
    if (!this.ShipNowChargeBreakupList || this.ShipNowChargeBreakupList.length === 0) {
      return;
    }
    console.log(Id,Name);
    this.ShipNowChargeBreakupList.forEach(element => {
      element.VehicleTypeId = Id;
      element.VehicleName = Name;
    });
  }

  UpdateBiddingDetails(Id,VehicleTypeId){
    if (!this.BiddingDetails || !this.BiddingDetails.length) return;
    const data = this.BiddingDetails.find(x => x.Id === Id);
    if (!data) return;

    data.VehicleTypeId = VehicleTypeId;
  }
  //added by BURHAN - 13-May-2026
  loadAttachmentSettings() {
    this._appService.GetById("Common", "GetSystemSettingByName", "BiddingAttachmentView").subscribe((res: any) => {
      this.canViewAttachment = String(res).replace(/"/g, '') === '1';
      console.log('canViewAttachment:', this.canViewAttachment, 'API:', res);
    });

    this._appService.GetById("Common", "GetSystemSettingByName", "BiddingAttachmentEdit").subscribe((res: any) => {
      this.canEditAttachment = String(res).replace(/"/g, '') === '1';
      console.log('canEditAttachment:', this.canEditAttachment, 'API:', res);
    });
  }

  onSelectItemNew(event: any) {
    console.log('Selected Button :', event);
    if (event.name === 'Attachments' || event.PrintName === 'Attachments') {
      this.openAttachmentModal();
    }
  }
  openAttachmentModal() {
    this.attachmentModalRef = this.modalService.open(this.attachment, {
      centered: true,
      size: 'lg'
    });
  }

  closeAttachmentModal() {
    if (this.attachmentModalRef) {
      this.attachmentModalRef.close();
    }
  }

  openAttachments() {
    this.isAttachmentShow = true;
  }
  //end by BURHAN
}
